import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ManagementRoutingModule } from './management-routing.module';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRadioModule } from '@angular/material/radio';
import {SearchFilterComponent} from '@emm/management/components/search-filter/search-filter.component';
import {SharedModule} from '@emm/shared/shared.module';
import {ConsumerManagerComponent} from '@emm/management/components/consumer-manager/consumer-manager.component';
import {
    ConsumerManagerFormComponent
} from '@emm/management/components/consumer-manager-form/consumer-manager-form.component';
import {ConsumerTypesComponent} from '@emm/management/components/consumer-types/consumer-types.component';
import {OperatorLocksComponent} from '@emm/management/components/emergency-items/operator-locks.component';
import {
    OperatorLocksFormComponent
} from '@emm/management/components/emergency-items-form/operator-locks-form.component';
import {GenericItemsListComponent} from '@emm/management/components/generic-items-list/generic-items-list.component';
import {GenericItemsTreeComponent} from '@emm/management/components/generic-items-tree/generic-items-tree.component';
import {ItemCreationFormComponent} from '@emm/management/components/item-creation-form/item-creation-form.component';
import {
    ItemDuplicationFormComponent
} from '@emm/management/components/item-duplication-form/item-duplication-form.component';
import {ItemGroupingsComponent} from '@emm/management/components/item-groupings/item-groupings.component';
import {ItemIdMappingsComponent} from '@emm/management/components/item-id-mappings/item-id-mappings.component';
import {
    ItemIdMappingsFormComponent
} from '@emm/management/components/item-id-mappings-form/item-id-mappings-form.component';
import {ItemTypesComponent} from '@emm/management/components/item-types/item-types.component';
import {ItemTypesFormComponent} from '@emm/management/components/item-types-form/item-types-form.component';
import {ItemsComponent} from '@emm/management/components/items/items.component';
import {ItemsFormComponent} from '@emm/management/components/items-form/items-form.component';
import {
    LanguageAssignmentsComponent
} from '@emm/management/components/language-assignments/language-assignments.component';
import {
    LanguageAssignmentsFormComponent
} from '@emm/management/components/language-assignments-form/language-assignments-form.component';
import {LocationSetTypesComponent} from '@emm/management/components/location-set-types/location-set-types.component';
import {
    LocationSetTypesFormComponent
} from '@emm/management/components/location-set-types-form/location-set-types-form.component';
import {LocationSetsComponent} from '@emm/management/components/location-sets/location-sets.component';
import {LocationSetsFormComponent} from '@emm/management/components/location-sets-form/location-sets-form.component';
import {ManagementComponent} from '@emm/management/components/management/management.component';
import {
    ManagementAttributeGroupsComponent
} from '@emm/management/components/management-attribute-groups/management-attribute-groups.component';
import {
    ManagementAttributesCreationFormComponent
} from '@emm/management/components/management-attributes/management-attributes-creation-form/management-attributes-creation-form.component';
import {
    ManagementAttributesFooterComponent
} from '@emm/management/components/management-attributes/management-attributes-footer/management-attributes-footer.component';
import {
    ManagementAttributesFormComponent
} from '@emm/management/components/management-attributes/management-attributes-form/management-attributes-form.component';
import {
    ManagementAttributesHeaderComponent
} from '@emm/management/components/management-attributes/management-attributes-header/management-attributes-header.component';
import {
    ManagementAttributesComponent
} from '@emm/management/components/management-attributes/management-attributes.component';
import {ManagementLayoutComponent} from '@emm/management/components/management-layout/management-layout.component';
import {MmsAdminComponent} from '@emm/management/components/mms-admin/mms-admin.component';
import {
    ManagementMasterMenuSystemComponent
} from '@emm/management/components/mms-revote/management-master-menu-system.component';
import {MmsRevoteFormComponent} from '@emm/management/components/mms-revote-form/mms-revote-form.component';
import {
    NutritionAssignmentsFormComponent
} from '@emm/management/components/nutrition-assignments/nutrition-assignments-form/nutrition-assignments-form.component';
import {
    NutritionAssignmentsListComponent
} from '@emm/management/components/nutrition-assignments/nutrition-assignments-list/nutrition-assignments-list.component';
import {
    NutritionAssignmentsLocationSetsListComponent
} from '@emm/management/components/nutrition-assignments/nutrition-assignments-location-sets/nutrition-assignments-location-sets-list/nutrition-assignments-location-sets-list';
import {
    NutritionAssignmentsLocationSetsComponent
} from '@emm/management/components/nutrition-assignments/nutrition-assignments-location-sets/nutrition-assignments-location-sets.component';
import {
    NutritionAssignmentsRightFooterComponent
} from '@emm/management/components/nutrition-assignments/nutrition-assignments-right-footer/nutrition-assignments-right-footer.component';
import {
    NutritionAssignmentsRightHeaderComponent
} from '@emm/management/components/nutrition-assignments/nutrition-assignments-right-header/nutrition-assignments-right-header.component';
import {
    LocationSetsDropdownComponent
} from '@emm/management/components/nutrition-assignments/nutrition-assignments-search/location-sets-dropdown/location-sets-dropdown.component';
import {
    SearchByLocationComponent
} from '@emm/management/components/nutrition-assignments/nutrition-assignments-search/search-by-location/search-by-location.component';
import {
    NutritionAssignmentsSearchComponent
} from '@emm/management/components/nutrition-assignments/nutrition-assignments-search/nutrition-assignments-search.component';
import {
    NutritionAssignmentsComponent
} from '@emm/management/components/nutrition-assignments/nutrition-assignments.component';
import {PinOverridesComponent} from '@emm/management/components/pin-overrides/pin-overrides.component';
import {PinOverridesFormComponent} from '@emm/management/components/pin-overrides-form/pin-overrides-form.component';
import {AttributeGroupsFacadeService} from '@emm/management/services/attribute-groups-facade.service';
import {AttributesFacadeService} from '@emm/management/services/attributes-facade.service';
import {ConsumerTypesFacadeService} from '@emm/management/services/consumer-types-facade.service';
import {ItemGroupingsFacadeService} from '@emm/management/services/item-groupings-facade.service';
import {ItemTypesFacadeService} from '@emm/management/services/item-types-facade.service';
import {ItemsFacadeService} from '@emm/management/services/items-facade.service';
import {LanguageAssignmentsService} from '@emm/management/services/language-assignments.service';
import {LanguageAssignmentsFacadeService} from '@emm/management/services/language-assignments-facade.service';
import {LocationSetTypesFacadeService} from '@emm/management/services/location-set-types-facade.service';
import {LocationSetsFacadeService} from '@emm/management/services/location-sets-facade.service';
import {ManagementApiService} from '@emm/management/services/management-api.service';
import {ManagementFacadeService} from '@emm/management/services/management-facade.service';
import {ManagementStoreService} from '@emm/management/services/management-store.service';
import {MasterMenuFacadeService} from '@emm/management/services/master-menu-facade.service';
import {MmsAdminOverrideFacadeService} from '@emm/management/services/mms-admin-override-facade.service';
import {NutritionFacadeService} from '@emm/management/services/nutrition-facade.service';
import {OperatorLocksFacadeService} from '@emm/management/services/operator-locks-facade.service';
import {managementFeatureKey, managementReducers} from '@emm/management/store/management.reducer';
import {AttributesEffects} from '@emm/management/services/effects/attributes.effects';
import {ConsumerTypesEffects} from '@emm/management/services/effects/consumer-types.effects';
import {OperatorLocksEffects} from '@emm/management/services/effects/operator-locks-effects.service';
import {ItemGroupingsEffects} from '@emm/management/services/effects/item-groupings.effects';
import {ItemTypeClassesEffects} from '@emm/management/services/effects/item-type-classes.effects';
import {ItemTypesEffects} from '@emm/management/services/effects/item-types.effects';
import {ItemsEffects} from '@emm/management/services/effects/items.effects';
import {LocationSetTypesEffects} from '@emm/management/services/effects/location-set-types.effects';
import {ManagementLocationSetsEffects} from '@emm/management/services/effects/management-location-sets-effects.service';
import {MasterMenuSystemEffects} from '@emm/management/services/effects/master-menu-system.effects';
import {MmsAdminOverrideEffects} from '@emm/management/services/effects/mms-admin-override.effects';
import {NutritionEffects} from '@emm/management/services/effects/nutrition.effects';
import {
    ManagementAttributeGroupsFormComponent
} from '@emm/management/components/management-attribute-groups/management-attribute-groups-form/management-attribute-groups-form.component';
import {OperationsComponent} from '@emm/management/components/operations/operations.component';
import {ManagementBaseEffects} from '@emm/management/services/effects/management-base-effects.service';
import {MenuPublishingService} from '@emm/core/services/menu-publishing.service';
import {
    OperationsRightHeader
} from "@emm/management/components/operations/operations-right-header/operations-right-header";

@NgModule({
    declarations: [
        ConsumerManagerComponent,
        ConsumerManagerFormComponent,
        ConsumerTypesComponent,
        OperatorLocksComponent,
        OperatorLocksFormComponent,
        GenericItemsListComponent,
        GenericItemsTreeComponent,
        ItemCreationFormComponent,
        ItemDuplicationFormComponent,
        ItemGroupingsComponent,
        ItemIdMappingsComponent,
        ItemIdMappingsFormComponent,
        ItemTypesComponent,
        ItemTypesFormComponent,
        ItemsComponent,
        ItemsFormComponent,
        LanguageAssignmentsComponent,
        LanguageAssignmentsFormComponent,
        LocationSetTypesComponent,
        LocationSetTypesFormComponent,
        LocationSetsComponent,
        LocationSetsFormComponent,
        ManagementComponent,
        ManagementAttributeGroupsComponent,
        ManagementAttributesCreationFormComponent,
        ManagementAttributesFooterComponent,
        ManagementAttributesFormComponent,
        ManagementAttributesHeaderComponent,
        ManagementAttributesComponent,
        ManagementLayoutComponent,
        MmsAdminComponent,
        ManagementMasterMenuSystemComponent,
        MmsRevoteFormComponent,
        NutritionAssignmentsFormComponent,
        NutritionAssignmentsListComponent,
        NutritionAssignmentsLocationSetsListComponent,
        NutritionAssignmentsLocationSetsComponent,
        NutritionAssignmentsRightFooterComponent,
        NutritionAssignmentsRightHeaderComponent,
        LocationSetsDropdownComponent,
        SearchByLocationComponent,
        NutritionAssignmentsSearchComponent,
        NutritionAssignmentsComponent,
        PinOverridesComponent,
        PinOverridesFormComponent,
        SearchFilterComponent,
        ManagementAttributeGroupsFormComponent,
        OperationsComponent,
        OperationsRightHeader

    ],
    exports: [
        SearchFilterComponent,
        GenericItemsTreeComponent
    ],
    providers: [
        AttributeGroupsFacadeService, AttributesFacadeService, ConsumerTypesFacadeService,
        ItemGroupingsFacadeService, ItemTypesFacadeService, ItemsFacadeService,
        LanguageAssignmentsService, LanguageAssignmentsFacadeService, LocationSetTypesFacadeService,
        LocationSetsFacadeService, ManagementApiService, ManagementFacadeService,
        ManagementStoreService, MasterMenuFacadeService, MmsAdminOverrideFacadeService,
        NutritionFacadeService, OperatorLocksFacadeService, MenuPublishingService
    ],
    imports: [
        SharedModule,
        ManagementRoutingModule,
        StoreModule.forFeature(managementFeatureKey, managementReducers),
        EffectsModule.forFeature(
            AttributesEffects, ConsumerTypesEffects, OperatorLocksEffects,
            ItemGroupingsEffects, ItemTypeClassesEffects, ItemTypesEffects,
            ItemsEffects, LocationSetTypesEffects, ManagementLocationSetsEffects,
            MasterMenuSystemEffects, MmsAdminOverrideEffects, NutritionEffects,
            ManagementBaseEffects
        ),
        MatButtonToggleModule,
        MatRadioModule,
    ]
})
export class ManagementModule {}
